import {
  BiAlignMiddle,
  BiBarChartSquare,
  BiCreditCard,
  BiDollarCircle,
  BiGroup,
  BiStats,
  BiUser,
  BiUserPin,
  BiUserPlus,
} from 'react-icons/bi'
import { FaAlignCenter, FaHome, FaReact } from 'react-icons/fa'
import { BiDetail } from 'react-icons/bi'
import { Account, UserTypes } from 'types/account.types'
import { useAuth } from 'utils/auth-context'
import { SIDE_NAV } from './sideNav.i18n'
import { BsStack } from 'react-icons/bs'
import { MdRoom } from 'react-icons/md'

type Menu = {
  pathTo: string
  title: string
  Icon: React.ElementType
  color: string
}

type Menus = {
  [key in UserTypes]: Array<Menu>
}

// Show tab on preprod only
const ShowForPreProd = window.location.href.includes('preprod')
export const ShowForPreProdAndLocal = ShowForPreProd || window.location.href.includes('localhost:')

export const MENU_ROLE_BASED: Menus = {
  [UserTypes.vendor]: [
    {
      pathTo: '/vendorDashboard',
      title: `${SIDE_NAV}.dashboard`,
      Icon: FaHome,
      color: '#F6AD55',
    },
    {
      pathTo: '/tickets',
      title: `${SIDE_NAV}.tickets`,
      Icon: FaAlignCenter,
      color: '#4E87F8',
    },
    {
      pathTo: '/vendors',
      title: `${SIDE_NAV}.profile`,
      Icon: BiUser,
      color: '#68D391',
    },
  ],

  [UserTypes.pc]: [
    // {
    //   pathTo: '/pcDashboard',
    //   title: 'Dashboard',
    //   Icon: FaHome,
    //   color: '#ED8936',
    // },
    {
      pathTo: '/tickets',
      title: `${SIDE_NAV}.workOrder`,
      Icon: BsStack,
      color: '#4E87F8',
    },
    {
      pathTo: '/property',
      title: `${SIDE_NAV}.property`,
      Icon: FaAlignCenter,
      color: '#4E87F8',
    },
    {
      pathTo: '/payable',
      title: `${SIDE_NAV}.payable`,
      Icon: BiCreditCard,
      color: '#68D391',
    },
    {
      pathTo: '/receivable',
      title: `${SIDE_NAV}.receivable`,
      Icon: BiDollarCircle,
      color: '#4299E1',
    },
    {
      pathTo: '/vendors',
      title: `${SIDE_NAV}.vendors`,
      Icon: BiUserPin,
      color: '#9F7AEA',
    },
    // {
    //   pathTo: '/alerts',
    //   title: 'Alerts',
    //   Icon: BiError,
    //   color: '#ED64A6',
    // },
    {
      pathTo: '/clients',
      title: `${SIDE_NAV}.clients`,
      Icon: BiGroup,
      color: '#0BC5EA',
    },
  ],

  [UserTypes.vendorManager]: [
    {
      pathTo: '/vendors',
      title: `${SIDE_NAV}.vendors`,
      Icon: BiUserPin,
      color: '#9F7AEA',
    },
    {
      pathTo: '/vendorSkills',
      title: `${SIDE_NAV}.vendorsSkills`,
      Icon: BiAlignMiddle,
      color: '#4E87F8',
    },
    {
      pathTo: '/markets',
      title: `${SIDE_NAV}.markets`,
      Icon: BiStats,
      color: '#68D391',
    },
  ],

  [UserTypes.doc]: [
    {
      pathTo: '/property',
      title: `${SIDE_NAV}.property`,
      Icon: FaAlignCenter,
      color: '#4E87F8',
    },
    {
      pathTo: '/vendors',
      title: `${SIDE_NAV}.vendors`,
      Icon: BiUserPin,
      color: '#9F7AEA',
    },
    {
      pathTo: '/clients',
      title: `${SIDE_NAV}.clients`,
      Icon: BiGroup,
      color: '#0BC5EA',
    },
  ],

  [UserTypes.fpm]: [
    {
      pathTo: '/tickets',
      title: `${SIDE_NAV}.workOrder`,
      Icon: BsStack,
      color: '#4E87F8',
    },
    {
      pathTo: '/property',
      title: `${SIDE_NAV}.property`,
      Icon: FaAlignCenter,
      color: '#4E87F8',
    },
  ],

  [UserTypes.publicAdmin]: [
    {
      pathTo: '/property',
      title: `${SIDE_NAV}.property`,
      Icon: FaAlignCenter,
      color: '#4E87F8',
    },
    {
      pathTo: '/projects',
      title: `${SIDE_NAV}.projects`,
      Icon: FaAlignCenter,
      color: '#4E87F8',
    },
    {
      pathTo: '/payable',
      title: `${SIDE_NAV}.payable`,
      Icon: BiCreditCard,
      color: '#68D391',
    },
    {
      pathTo: '/receivable',
      title: `${SIDE_NAV}.receivable`,
      Icon: BiDollarCircle,
      color: '#4299E1',
    },
    {
      pathTo: '/vendors',
      title: `${SIDE_NAV}.vendors`,
      Icon: BiUserPin,
      color: '#9F7AEA',
    },
    {
      pathTo: '/clients',
      title: `${SIDE_NAV}.clients`,
      Icon: BiGroup,
      color: '#0BC5EA',
    },

    {
      pathTo: '/markets',
      title: `${SIDE_NAV}.markets`,
      Icon: BiStats,
      color: '#68D391',
    },
    {
      pathTo: '/projectType',
      title: 'Project type',
      Icon: MdRoom,
      color: '#9B2C2C',
    },
    {
      pathTo: '/vendorSkills',
      title: `${SIDE_NAV}.vendorsSkills`,
      Icon: BiAlignMiddle,
      color: '#4E87F8',
    },
  ],
  [UserTypes.admin]: [
    {
      pathTo: '/tickets',
      title: `${SIDE_NAV}.workOrder`,
      Icon: BsStack,
      color: '#4E87F8',
    },
    {
      pathTo: '/property',
      title: `${SIDE_NAV}.property`,
      Icon: BiDetail,
      color: '#FC8181',
    },
    {
      pathTo: '/payable',
      title: `${SIDE_NAV}.payable`,
      Icon: BiCreditCard,
      color: '#68D391',
    },
    {
      pathTo: '/receivable',
      title: `${SIDE_NAV}.receivable`,
      Icon: BiDollarCircle,
      color: '#4299E1',
    },
    {
      pathTo: '/vendors',
      title: `${SIDE_NAV}.vendors`,
      Icon: BiUserPin,
      color: '#9F7AEA',
    },
    {
      pathTo: '/clients',
      title: `${SIDE_NAV}.clients`,
      Icon: BiGroup,
      color: '#0BC5EA',
    },

    {
      pathTo: '/reportsDashboard',
      title: `${SIDE_NAV}.reports`,
      Icon: BiBarChartSquare,
      color: '#FC8181',
    },

    {
      pathTo: '/userManager',
      title: `${SIDE_NAV}.userMgmt`,
      Icon: BiUserPlus,
      color: '#ECC94B',
    },
    {
      pathTo: '/markets',
      title: `${SIDE_NAV}.markets`,
      Icon: BiStats,
      color: '#68D391',
    },
    {
      pathTo: '/projectType',
      title: `${SIDE_NAV}.projectType`,
      Icon: MdRoom,
      color: '#9B2C2C',
    },
    {
      pathTo: '/vendorSkills',
      title: `${SIDE_NAV}.vendorsSkills`,
      Icon: BiAlignMiddle,
      color: '#4E87F8',
    },
    {
      pathTo: '/support-tickets',
      title: `${SIDE_NAV}.support`,
      Icon: FaReact,
      color: '#3182CE',
    },
  ],

  [UserTypes.accounting]: [
    {
      pathTo: '/tickets',
      title: `${SIDE_NAV}.workOrder`,
      Icon: BsStack,
      color: '#4E87F8',
    },
    {
      pathTo: '/payable',
      title: `${SIDE_NAV}.payable`,
      Icon: BiCreditCard,
      color: '#68D391',
    },
    {
      pathTo: '/receivable',
      title: `${SIDE_NAV}.receivable`,
      Icon: BiDollarCircle,
      color: '#4299E1',
    }
  ],
  [UserTypes.operations]: [
    {
      pathTo: '/property',
      title: `${SIDE_NAV}.property`,
      Icon: FaAlignCenter,
      color: '#4E87F8',
    },
    {
      pathTo: '/payable',
      title: `${SIDE_NAV}.payable`,
      Icon: BiCreditCard,
      color: '#68D391',
    },
    {
      pathTo: '/receivable',
      title: `${SIDE_NAV}.receivable`,
      Icon: BiDollarCircle,
      color: '#4299E1',
    },
    {
      pathTo: '/vendors',
      title: `${SIDE_NAV}.vendors`,
      Icon: BiUserPin,
      color: '#9F7AEA',
    },
    {
      pathTo: '/clients',
      title: `${SIDE_NAV}.clients`,
      Icon: BiGroup,
      color: '#0BC5EA',
    },
    {
      pathTo: '/reportsDashboard',
      title: `${SIDE_NAV}.reports`,
      Icon: BiBarChartSquare,
      color: '#FC8181',
    },
    // {
    //   pathTo: '/userManager',
    //   title: 'User Mgmt',
    //   Icon: BiUserPlus,
    //   color: '#ECC94B',
    // },
  ],
  [UserTypes.clientManager]: [
    {
      pathTo: '/clients',
      title: `${SIDE_NAV}.clients`,
      Icon: BiGroup,
      color: '#0BC5EA',
    },
  ],
  [UserTypes.constructionOperations]: [
    {
      pathTo: '/property',
      title: `${SIDE_NAV}.property`,
      Icon: FaAlignCenter,
      color: '#4E87F8',
    },
    {
      pathTo: '/vendors',
      title: `${SIDE_NAV}.vendors`,
      Icon: BiUserPin,
      color: '#9F7AEA',
    },
  ],
}

export const useRoleBasedMenu = (): Array<Menu> => {
  const urlParams = new URLSearchParams(window.location.search)
  const isEmbedded = urlParams.get('embedded')
  const { data } = useAuth()
  if (isEmbedded) return []

  const { userTypeLabel } = data?.user as Account

  return MENU_ROLE_BASED[userTypeLabel] || []
}

export const APP_LOCAL_DATE_FORMAT_Z = 'yyyy-MM-dd'


export const DEFAULT_VENDOR_NOT_ASSIGNED_WO = 100001;